import * as React from "react";
import { Menu, Icon, Modal } from "antd";
import { useState, useEffect } from "src/ReactTS";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { AuthContext } from "src/components/context/AuthContext";
import { jsonMenu } from "./side-menu-json";

function SideMenu(props: { setMenuClicked: React.Dispatch<React.SetStateAction<string>> } & RouteComponentProps<any>) {
  const { pathname } = props.history.location;
  const [currentKey, setKey] = useState("");
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const { currentUser } = React.useContext(AuthContext);
  const RouteTreeRules: string[] = currentUser ? currentUser.profiles.map(e => e.rules.map(x => x.name)).flat(1).concat(currentUser.rules.map(e => e.name)) : [];
  const distinctRulesArray = [...new Set(RouteTreeRules)];

  useEffect(() => {
    props.setMenuClicked(currentKey);
  }, [currentKey]);

  useEffect(() => {
    if (pathname.indexOf("/gerencial/precatorios") > -1 && distinctRulesArray.includes("RULE_OFFICER_GERENCIAL_PRECATORIOS")) {
      setKey("Precatórios");
      setOpenKeys(["Gerencial"]);
    } else if (pathname.indexOf("/gerencial/cotacoes") > -1 && distinctRulesArray.includes("RULE_OFFICER_GERENCIAL_QUOTES")) {
      setKey("Cotações");
      setOpenKeys(["Gerencial"]);
    } else if (pathname.indexOf("/gerencial/operacoes") > -1 && distinctRulesArray.includes("RULE_OFFICER_GERENCIAL_OPERATIONS")) {
      setKey("Operações");
      setOpenKeys(["Gerencial"]);
    } else if (pathname.indexOf("/nf-payment/request") > -1 && distinctRulesArray.includes("RULE_OFFICER_VIEW_NF_PAYMENT_REQUEST")) {
      setKey("Solicitar");
      setOpenKeys(["Solicitação de pagamento"]);
    } else if (pathname.indexOf("/nf-payment/demmanded") > -1 && distinctRulesArray.includes("RULE_OFFICER_VIEW_NF_PAYMENT_DEMMANDED")) {
      setKey("Solicitado");
      setOpenKeys(["Solicitação de pagamento"]);
    } else if (pathname.indexOf("/nf-payment/scheduled") > -1 && distinctRulesArray.includes("RULE_OFFICER_VIEW_NF_PAYMENT_SCHEDULED")) {
      setKey("Agendado");
      setOpenKeys(["Solicitação de pagamento"]);
    } else if (pathname.indexOf("/nf-payment/paid") > -1 && distinctRulesArray.includes("RULE_OFFICER_VIEW_NF_PAYMENT_PAID")) {
      setKey("Pago");
      setOpenKeys(["Solicitação de pagamento"]);
    } else if (pathname.indexOf("/nf-payment/in-review") > -1 && distinctRulesArray.includes("RULE_OFFICER_VIEW_NF_PAYMENT_IN_REVIEW")) {
      setKey("Em revisão");
      setOpenKeys(["Solicitação de pagamento"]);
    } else if (pathname.indexOf("/nf-payment/rejected") > -1 && distinctRulesArray.includes("RULE_OFFICER_VIEW_NF_PAYMENT_REJECTED")) {
      setKey("Rejeitado");
      setOpenKeys(["Solicitação de pagamento"]);
    } else if (pathname.indexOf("/monitor/precatorios/list") > -1 && distinctRulesArray.includes("RULE_OFFICER_MONITOR_PRECATORIOS_LIST")) {
      setKey("Listar");
      setOpenKeys(["Monitor", "Meus Precatórios"]);
    } else if (pathname.indexOf("/monitor/cotacoes/user") > -1 && distinctRulesArray.includes("RULE_OFFICER_MONITOR_QUOTES")) {
      setKey("Minhas Cotações");
      setOpenKeys(["Monitor", "Cotações"]);
    } else if (pathname.indexOf("/monitor/cotacoes/all") > -1 && distinctRulesArray.includes("RULE_OFFICER_USER_CAN_VIEW_ALL_QUOTES")) {
      setKey("Todas Cotações");
      setOpenKeys(["Monitor", "Cotações"]);
    } else if (pathname.indexOf("/monitor/pre-precatorio/all") > -1 && distinctRulesArray.includes("RULE_OFFICER_USER_CAN_VIEW_ALL_PRE_PRECATORIO")) {
      setKey("Todas Cotações de Pré-Precatorios");
      setOpenKeys(["Monitor", "Cotações"]);
    } else if (pathname.indexOf("/monitor/operacoes") > -1 && distinctRulesArray.includes("RULE_OFFICER_MONITOR_OPERATIONS")) {
      setKey("Minhas Operações");
      setOpenKeys(["Monitor"]);
    } else if (pathname.indexOf("/monitor/operacoes-com-pendencias") > -1 && distinctRulesArray.includes("RULE_OFFICER_MONITOR_PENDENCY_OPERATIONS")) {
      setKey("Operações com pendências");
      setOpenKeys(["Monitor"]);
    } else if (pathname.indexOf("/monitor/pending-sent") > -1 && distinctRulesArray.includes("RULE_OFFICER_PENDING_SENT")) {
      setKey("Pendências enviadas");
      setOpenKeys(["Monitor"]);
    }
    else if (pathname.indexOf("/monitor/archived") > -1 && distinctRulesArray.includes("RULE_OFFICER_MONITOR_ARCHIVED")) {
      setKey("Operações Arquivadas");
      setOpenKeys(["Monitor"]);
    } else if (pathname.indexOf("/monitor/rejected") > -1 && distinctRulesArray.includes("RULE_OFFICER_MONITOR_REJECTED")) {
      setKey("Operações Rejeitadas");
      setOpenKeys(["Monitor"]);
    } else if (pathname.indexOf("/monitor/upload") > -1 && distinctRulesArray.includes("RULE_OFFICER_MONITOR_UPLOAD")) {
      setKey("Upload de Documentos");
      setOpenKeys(["Monitor"]);
    } else if (pathname.indexOf("/monitor/notificar") > -1 && distinctRulesArray.includes("RULE_OFFICER_MONITOR_NOTIFY")) {
      setKey("Notificar Clientes");
      setOpenKeys(["Monitor"]);
    } else if (pathname.indexOf("/monitor/trade-post-purchase") > -1 && distinctRulesArray.includes("RULE_OFFICER_VIEW_TRADE_POST_PURCHASE")) {
      setKey("Usuários");
      setOpenKeys(["Monitor"]);
    } else if (pathname.indexOf("/ferramentas/calculadora/manual") > -1 && distinctRulesArray.includes("RULE_OFFICER_TOOLS_CALCULATOR_MANUAL")) {
      setKey("Calculadora Manual");
      setOpenKeys(["Ferramentas"]);
    } else if (pathname.indexOf("/monitor/precatorios/consult") > -1 && distinctRulesArray.includes("RULE_OFFICER_MONITOR_PRECATORIOS_CONSULT")) {
      setKey("Consultar");
      setOpenKeys(["Ferramentas"]);
    }
    else if (pathname.indexOf("/usarios") > -1 && distinctRulesArray.includes("RULE_OFFICER_ADMIN_USERS")) {
      setKey("Usuários");
      setOpenKeys(["Administração"]);
    }
  }, []);
  const onOpenChange = openKeysArray => {
    if (openKeysArray.length > 0) {
      const latestOpenKey = openKeysArray.find(key => openKeys.indexOf(key) === -1);

      if (openKeysArray.length > 1) {
        if (openKeysArray[0] === "Monitor" && openKeysArray[1] === "Meus Precatórios") {
          if (openKeysArray.length === 3) {
            openKeysArray.shift();
            setOpenKeys(openKeysArray);
            setKey("");
          } else {
            setKey("");
            setOpenKeys(openKeysArray);
          }
        } else if (openKeysArray[0] === "Monitor" && openKeysArray[1] === "Cotações") {
          if (openKeysArray.length === 3) {
            openKeysArray.shift();
            setOpenKeys(openKeysArray);
            setKey("");
          } else {
            setKey("");
            setOpenKeys(openKeysArray);
          }
        } else {
          setKey("");
          setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
      } else if (openKeysArray.length === 1) {
        setKey("");
        setOpenKeys(latestOpenKey ? [latestOpenKey] : openKeysArray);
      }
    } else if (openKeysArray.length === 0) {
      setKey("");
      setOpenKeys([]);
    }
  };

  function MenuTree(Tree: any[]): any {
    return Tree.map(item => {
      if (item.match === "#" && distinctRulesArray.includes(item.rule)) {
        return (
          <Menu.SubMenu
            key={item.name}
            title={
              <span>
                <Icon type={item.icon} />
                <span>{item.name}</span>
              </span>
            }
          >
            {MenuTree(item.items)}
          </Menu.SubMenu>
        );
      } else if (item.match !== "#" && distinctRulesArray.includes(item.rule)) {
        return (
          <Menu.Item key={item.name} disabled={item.rule === "RULE_OFFICER_TOOLS_BACKGROUNDCHECK" ? true : false}>
            <Link to={item.match}>
              <Icon type={item.icon} />
              <span>{item.name}</span>
            </Link>
          </Menu.Item>
        );
      } else {
        return null;
      }
    });
  }

  return (
    <Menu
      theme="dark"
      mode="inline"
      openKeys={openKeys}
      onClick={e => {
        if (e.key !== "Logout") {
          setKey(e.key);
        }
      }}
      selectedKeys={[currentKey]}
      onOpenChange={e => onOpenChange(e)}
    >
      {MenuTree(jsonMenu)}
      <Menu.Item key="Logout">
        <a
          onClick={() => {
            Modal.confirm({
              title: "Deseja realmente sair?",
              onOk: () => props.history.push("/logout")
            });
          }}
        >
          <Icon type="logout" />
          <span>Sair</span>
        </a>
      </Menu.Item>
    </Menu>
  );
}

export default withRouter(SideMenu);



// WEBPACK FOOTER //
// ./src/components/common/side-menu/side-menu.tsx